import { green } from '@ant-design/colors';
import {
  CheckCircleOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import TableAndFilters from '../../components/TableAndFilters';
import EmpresaContext from '../../context/empresa-context';
import { DEFAULT_PAGE_SIZE, errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { fieldTypes } from '../../utils/filter-utils';

const styles = {
  menuAction: {
    marginLeft: 10
  }
};

function JobList(props) {
  const { empresa } = useContext(EmpresaContext);
  const columns = [
    {
      title: 'Tipo',
      dataIndex: 'tipo',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Estado',
      dataIndex: 'activo',
      filterType: fieldTypes.STRING,
      sortable: true
    },
    {
      title: 'Fecha Inicio',
      dataIndex: 'inicio',
      filterType: fieldTypes.DATE,
      sortable: true
    },
    {
      title: 'Fecha Fin',
      dataIndex: 'fin',
      filterType: fieldTypes.DATE,
      sortable: true
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Ver">
            <Button
              type="text"
              icon={<EyeOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`jobs/view/${record.id}`)}
            />
          </Tooltip>
          <Tooltip title="Editar">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`jobs/form/${record.id}`)}
            />
          </Tooltip>
          <Tooltip title={record.activo ? 'Desactivar' : 'Activar'}>
            <Button
              type="text"
              style={record.activo ? { color: green.primary } : {}}
              danger={!record.activo}
              icon={<CheckCircleOutlined />}
              size="middle"
              loading={loadingState === record.id}
              onClick={() => toggle(record)}
            />
          </Tooltip>
        </Space>
      ),
      align: 'center'
    }
  ];

  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    showSizeChanger: true
  });
  const [loadingState, setLoadingState] = useState(0);
  const history = useHistory();

  const toggle = async (record) => {
    try {
      setLoadingState(record.id);
      if (record.activo) {
        await instanceRef.instance.post(`job/disable/${record.id}`, {
          username: record.correo
        });
      } else {
        await instanceRef.instance.post(`job/enable/${record.id}`, {
          username: record.correo
        });
      }
      setData({
        ...data,
        rows: data.rows.map((item) => {
          if (item.id === record.id) {
            // eslint-disable-next-line no-param-reassign
            item.activo = !record.activo;
          }
          return item;
        })
      });
    } catch (error) {
      errorHandler(error);
    }
    setLoadingState(0);
  };

  const fetch = async (propsParam) => {
    try {
      const response = await instanceRef.instance.get('job', {
        params: {
          ...propsParam.pagination,
          filters: { ...propsParam.filters }
        }
      });
      if (response.data?.data) {
        setData({ ...response.data.data });
        setPagination({
          ...propsParam.pagination,
          total: response.data.data.count
        });
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  useEffect(() => {
    if (empresa && empresa.id) {
      fetch({ pagination });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresa]);

  const tableRef = useRef();

  return (
    <ResponsiveContainer size="large">
      <div style={{ overflow: 'auto' }}>
        <TableAndFilters
          ref={tableRef}
          withGeneralFilter
          url="/job"
          title="Tareas Programadas"
          columns={columns}
          extra={[
            <Button
              key="2"
              type="dashed"
              shape="round"
              icon={<PlusOutlined />}
              size="middle"
              onClick={() => props.history.push(`jobs/form`)}
              style={styles.menuAction}
            >
              Agregar
            </Button>
          ]}
        />
      </div>
    </ResponsiveContainer>
  );
}

export default JobList;
